import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";
import { useSiteContent } from "./content";
import { ptDict } from "./ptI18n";

const dict = {
  nl: {
    "nav.home": "Home",
    "nav.about": "Over JOH.",
    "nav.trainings": "Trainingen",
    "nav.schedule": "Rooster",
    "nav.membership": "Membership",
    "nav.pt": "Personal Training",
    "nav.community": "Community",
    "nav.contact": "Contact",
    "nav.book": "Word lid",

    "hero.meta.est": "Amsterdam / Est. 2025",
    "hero.meta.ch": "Ch. 01 — Fundamentals",
    "hero.sub": "JOH. Boxing is een toegankelijke boxing community in Amsterdam voor iedereen die sterker, fitter en zelfverzekerder wil worden.",
    "hero.btn.trial": "Boek een gratis proefles",
    "hero.btn.schedule": "Bekijk het rooster",
    "hero.tag": "Master the fundamentals. Build each other. Keep progressing.",

    "intro.ch": "— Ch. 02 / Manifesto",
    "intro.p1": "Bij JOH. Boxing leer je meer dan alleen stoten. Je werkt aan techniek, conditie, discipline en zelfvertrouwen. Onze trainingen zijn toegankelijk voor beginners, maar uitdagend genoeg voor ervaren boksers.",
    "intro.p2": "Iedereen traint op zijn eigen niveau. We bouwen samen aan een sterke en betrokken community: een boksschool in Amsterdam voor volwassenen die zich willen ontwikkelen op vloer en daarbuiten.",

    "values.ch": "— Ch. 03 / Values",
    "values.sub": "Three principles / non-negotiable",
    "values.1": "Respect is de basis. Respect voor jezelf, voor elkaar en voor het vak.",
    "values.2": "Discipline is de keuze om te blijven komen, leren en werken, ook wanneer het zwaar wordt.",
    "values.3": "Unity is de kracht van samen. We trainen als individuen, maar groeien door elkaar sterker te maken.",

    "trainings.ch": "— Ch. 04 / Programme",
    "teaser.ch": "— This week at JOH.",
    "teaser.title": "The classes.",
    "teaser.sub": "Vaste groepslessen — bekijk het volledige rooster hieronder.",
    "teaser.btn": "Bekijk het rooster",
    "training.boxing101.b": "Toegankelijke basistraining. Bokshouding, dekking, stoten, voetenwerk, verdediging en conditie.",
    "training.boxing.b": "Complete groepsles: techniek, combinaties, pads, conditie, boksspecifieke oefeningen. Beginners en gevorderden.",
    "training.bag.b": "Energieke bokszak-sessie waarin techniek, tempo, conditie en kracht samenkomen.",
    "training.sparring.b": "Technisch en gecontroleerd. Timing, controle, reactievermogen en leren onder druk.",
    "training.pt.b": "Volledige aandacht en programma op maat: techniek, conditie, wedstrijdvoorbereiding of persoonlijke doelen.",

    "schedule.ch": "— Ch. 05 / Timetable",
    "schedule.day": "Dag",
    "schedule.time": "Tijd",
    "schedule.type": "Training",
    "schedule.level": "Niveau",
    "schedule.coach": "Coach",
    "schedule.note": "Het rooster kan periodiek worden aangepast. Bekijk altijd de actuele planning voordat je een training boekt.",
    "schedule.btn": "Reserveer je training",

    "membership.ch": "— Ch. 06 / Membership",
    "membership.blurb": "Bij JOH. geloven we dat kwalitatieve bokstraining voor iedereen toegankelijk moet zijn. Daarom combineren we de authentieke energie van de bokssport met professionele begeleiding en aandacht voor iedere bokser. Persoonlijke groei, kwaliteit en een sterke community staan centraal.",
    "membership.label": "Membership",
    "membership.month": "per maand",
    "membership.i1": "Toegang tot het JOH. Boxing-programma",
    "membership.i2": "Groepslessen volgens het actuele rooster",
    "membership.i3": "Boxing 101 & bokstechniek-conditie",
    "membership.i4": "Community-events",
    "membership.i5": "Mogelijkheid om door te groeien naar sparring",
    "membership.info1": "Maandelijks opzegbaar",
    "membership.info1.tag": "tijdens opstart",
    "membership.info2": "€12 eenmalig",
    "membership.info2.tag": "inschrijfkosten",
    "membership.info3": "Proefles mogelijk",
    "membership.info3.tag": "gratis",
    "membership.btn": "Start met JOH. Boxing",

    "about.ch": "— Ch. 07 / The Founder",
    "about.p1": "JOH. is ontstaan vanuit de overtuiging dat boksen mensen verder kan brengen dan alleen fysieke fitheid.",
    "about.p2": "Oprichter en trainer Glenn Mulala heeft meer dan tien jaar ervaring binnen de bokssport. Hij bokste op wedstrijdniveau, won goud tijdens het Noord-Nederlands Kampioenschap in 2014 en behoorde in 2015 tot de top vijf zwaargewichten van Nederland.",
    "about.p3": "Met JOH. Boxing wil hij een omgeving bouwen waarin kwaliteit en toegankelijkheid samenkomen. Een plek waar mensen leren boksen, discipline opbouwen en onderdeel worden van een sterke community.",
    "about.btn": "Train met JOH.",
    "about.stat1": "Jaar ervaring",
    "about.stat2": "Goud NNK '14",
    "about.stat3": "NL '15",

    "vision.ch": "— Ch. 08 / Philosophy",
    "vision.blurb": "Bij JOH. gaat boksen verder dan alleen techniek en conditie. Het is een manier om lichaam en geest sterker te maken, discipline op te bouwen en vertrouwen in jezelf te ontwikkelen. Vanuit respect voor elkaar creëren we een omgeving waarin iedereen wordt uitgedaagd om te groeien, als bokser én als persoon.",
    "vision.1.t": "Respect",
    "vision.1.b": "Respect voor jezelf, je trainer, je trainingspartner en de sport. Zonder respect is er geen groei.",
    "vision.2.t": "Body & Mind",
    "vision.2.b": "Boksen daagt lichaam en geest tegelijk uit. Je wordt fysiek sterker, mentaal scherper en leert kalm te blijven onder druk.",
    "vision.3.t": "Discipline",
    "vision.3.b": "Vooruitgang ontstaat door te blijven komen, te blijven luisteren en de basis te blijven herhalen — ook wanneer het moeilijk wordt.",
    "vision.4.t": "Confidence",
    "vision.4.b": "Zelfvertrouwen groeit niet door woorden, maar door ervaring. Iedere training laat je ontdekken waartoe je werkelijk in staat bent.",
    "vision.5.t": "Together",
    "vision.5.b": "Je ontwikkelt jezelf, maar je doet het niet alleen. We dagen elkaar uit, helpen elkaar groeien en bouwen samen aan een sterke community.",

    "community.ch": "— Ch. 09 / The Group",
    "community.blurb": "Bij JOH. Boxing draait het niet alleen om individuele prestaties. De groep speelt een belangrijke rol in de ontwikkeling van iedere deelnemer.",
    "community.invite": "Of je nu voor het eerst bokshandschoenen aantrekt of al jaren traint: je bent welkom om onderdeel te worden van JOH.",
    "community.btn": "Sluit je aan",

    "pt.ch": "— Ch. 10 / 1:1",
    "pt.blurb": "Met personal training krijg je volledige aandacht en een programma dat wordt afgestemd op jouw niveau, doelen en belastbaarheid.",
    "pt.g1": "Leren boksen", "pt.g2": "Techniek", "pt.g3": "Afvallen", "pt.g4": "Conditie",
    "pt.g5": "Sterker & explosief", "pt.g6": "Zelfvertrouwen", "pt.g7": "Sparring-prep", "pt.g8": "Wedstrijden",
    "pt.form.title": "— Aanvraag / Personal Training",
    "form.name": "Naam", "form.email": "E-mail", "form.phone": "Telefoon",
    "form.exp": "Ervaringsniveau", "form.goal": "Trainingsdoel", "form.day": "Voorkeursdag", "form.msg": "Bericht",
    "form.name.ph": "Voor & achternaam",
    "pt.form.submit": "Vraag een PT-sessie aan",

    "trial.ch": "— Ch. 11 / Free trial",
    "trial.blurb": "Ervaring is niet nodig. Kom kennismaken met de training, de trainer en de community. Volledig gratis, geen verplichting.",
    "trial.hint": "Vul het formulier in — we nemen binnen 24u contact op",
    "trial.form.title": "— Boek je gratis proefles",
    "trial.form.submit": "Boek je gratis proefles",

    "contact.ch": "— Ch. 12 / Contact",
    "contact.addr": "Rhoneweg 38, 1043 AH",
    "contact.addr.tag": "Amsterdam",
    "contact.form.title": "— Stuur ons een bericht",
    "contact.subject": "Onderwerp",
    "contact.submit": "Verstuur bericht",
    "subj.trial": "Proefles", "subj.membership": "Membership", "subj.pt": "Personal training",
    "subj.collab": "Samenwerking", "subj.youth": "Jeugdprogramma", "subj.other": "Overige vraag",

    "toast.trial.ok": "Proefles geboekt. Check je e-mail voor bevestiging.",
    "toast.pt.ok": "Aanvraag verstuurd. We nemen snel contact op.",
    "toast.contact.ok": "Bericht verstuurd. We reageren snel.",
    "toast.err": "Er ging iets mis. Probeer het opnieuw.",
    "loading.send": "Versturen…",

    "footer.tag": "Community.",
    "footer.line": "Boxing. Training.",
    "footer.nav": "Navigate",
    "footer.legal": "Legal",
    "footer.terms": "Algemene voorwaarden",
    "footer.privacy": "Privacybeleid",
    "footer.follow": "Volg",
    "footer.copy": "© JOH. Boxing 2026. All rights reserved.",
    "footer.made": "Built for the fundamentals. Made in Amsterdam.",

    // Grote display-koppen (standaard gestylde JSX; admin-override = platte tekst)
    "hero.h1.1": "Learn how", "hero.h1.2": "to box.", "hero.h1.3": "Step into", "hero.h1.4": "your potential.",
    "teaser.h1": "The classes.",
    "intro.h1.1": "Boxing is the", "intro.h1.2": "starting", "intro.h1.3": "point.",
    "values.h1.1": "Find your way", "values.h1.2": "into", "values.h1.3": "boxing.",
    "schedule.h1.1": "The week", "schedule.h1.2": "at JOH.",
    "membership.h1.1": "Become", "membership.h1.2": "part", "membership.h1.3": "of JOH.",
    "about.h1.1": "Built from", "about.h1.2": "experience.", "about.h1.3": "Created for", "about.h1.4": "community.",
    "vision.h1.1": "Master the", "vision.h1.2": "fundamentals.",
    "community.h1.1": "We build", "community.h1.2": "each", "community.h1.3": "other.",
    "pt.h1.1": "Your goal.", "pt.h1.2": "Your", "pt.h1.3": "session.",
    "trial.h1.1": "Do you want", "trial.h1.2": "to", "trial.h1.3": "learn", "trial.h1.4": "how to box?",
    "contact.h1.1": "Step", "contact.h1.2": "into", "contact.h1.3": "the", "contact.h1.4": "gym.",

    // Landingpage (/welkom + /landingpage)
    "welkom.back": "Volledige site",
    "welkom.tag": "Welkom / Gratis proefles",
    "welkom.h1.1": "Do you", "welkom.h1.2": "want to learn", "welkom.h1.3": "how to box?",
    "welkom.intro": "Ervaring is niet nodig. Kom kennismaken met de coach, voel de community en probeer boksen in je eigen tempo — volledig gratis.",
    "welkom.cta": "Aan de slag",
    "welkom.v1.t": "Geen ervaring nodig", "welkom.v1.b": "Start op dag één. De coach begeleidt je eerste stoten, houding en voetenwerk stap voor stap.",
    "welkom.v2.t": "Kleine groepen", "welkom.v2.b": "Groepen van 10–16. Persoonlijke aandacht, echte feedback, geen anonieme massa.",
    "welkom.v3.t": "Zonder verplichting", "welkom.v3.b": "Eén gratis les. Beslis daarna. Geen contract, geen druk, geen opzegkosten.",
    "welkom.gallery.tag": "Dit is de gym",
    "welkom.gallery.h1.1": "Echte zakken.", "welkom.gallery.h1.2": "Echte mensen.",
    "welkom.gallery.p": "Amsterdams, community-gedreven. Documentaire beelden — geen stock, geen filters, geen clichés.",
    "welkom.steps.tag": "Zo ziet je proefles eruit",
    "welkom.steps.h1.1": "Vijf stappen", "welkom.steps.h1.2": "op de vloer.",
    "welkom.s1.t": "Intake & welkom", "welkom.s1.b": "Kennismaken met de coach, jouw doel, gear check",
    "welkom.s2.t": "Warming-up", "welkom.s2.b": "Touwtjespringen, voetenwerk, mobiliteit",
    "welkom.s3.t": "Fundament", "welkom.s3.b": "Houding, dekking, jab, rechte",
    "welkom.s4.t": "Zak & pads", "welkom.s4.b": "Combinaties, tempo, ademhaling",
    "welkom.s5.t": "Cool down & vervolg", "welkom.s5.b": "Rekken, vragen, plan je volgende les",
    "welkom.form.tag": "Boek je proefles",
    "welkom.form.h1.1": "Eén tap.", "welkom.form.h1.2": "Nul druk.",
    "welkom.form.reply": "Reactie binnen 24u",
    "welkom.form.badge": "Gratis proefles · Zonder verplichting",
    "welkom.form.submit": "Boek mijn gratis proefles",
  },
  en: {
    "nav.home": "Home",
    "nav.about": "About JOH.",
    "nav.trainings": "Training",
    "nav.schedule": "Schedule",
    "nav.membership": "Membership",
    "nav.pt": "Personal Training",
    "nav.community": "Community",
    "nav.contact": "Contact",
    "nav.book": "Join JOH",

    "hero.meta.est": "Amsterdam / Est. 2025",
    "hero.meta.ch": "Ch. 01 — Fundamentals",
    "hero.sub": "JOH. Boxing is an accessible boxing community in Amsterdam for anyone who wants to get stronger, fitter and more confident.",
    "hero.btn.trial": "Book a free trial",
    "hero.btn.schedule": "See the schedule",
    "hero.tag": "Master the fundamentals. Build each other. Keep progressing.",

    "intro.ch": "— Ch. 02 / Manifesto",
    "intro.p1": "At JOH. Boxing you learn more than throwing punches. You work on technique, conditioning, discipline and confidence. Our classes are accessible for beginners, and challenging enough for experienced boxers.",
    "intro.p2": "Everyone trains at their own level. We build a strong, involved community: a boxing gym in Amsterdam for adults who want to grow, on and off the floor.",

    "values.ch": "— Ch. 03 / Values",
    "values.sub": "Three principles / non-negotiable",
    "values.1": "Respect is the foundation. Respect for yourself, for each other and for the craft.",
    "values.2": "Discipline is the choice to keep showing up, keep learning, keep working — even when it gets heavy.",
    "values.3": "Unity is the power of doing this together. We train as individuals, but grow by making each other stronger.",

    "trainings.ch": "— Ch. 04 / Programme",
    "teaser.ch": "— This week at JOH.",
    "teaser.title": "The classes.",
    "teaser.sub": "Weekly group classes — see the full timetable below.",
    "teaser.btn": "See the schedule",
    "training.boxing101.b": "An accessible fundamentals class. Stance, guard, punches, footwork, defence and conditioning.",
    "training.boxing.b": "Full group class: technique, combinations, pads, conditioning, boxing-specific drills. Beginner to advanced.",
    "training.bag.b": "High-energy bag session — technique, tempo, conditioning and power in one.",
    "training.sparring.b": "Technical and controlled. Timing, composure, reaction and learning under pressure.",
    "training.pt.b": "Full attention and a tailored programme: technique, conditioning, competition prep or personal goals.",

    "schedule.ch": "— Ch. 05 / Timetable",
    "schedule.day": "Day",
    "schedule.time": "Time",
    "schedule.type": "Class",
    "schedule.level": "Level",
    "schedule.coach": "Coach",
    "schedule.note": "The schedule may shift over time. Always check the current planning before booking a class.",
    "schedule.btn": "Reserve your session",

    "membership.ch": "— Ch. 06 / Membership",
    "membership.blurb": "At JOH. we believe quality boxing training should be accessible to everyone. That's why we combine the raw energy of boxing with professional guidance and attention for every boxer. Personal growth, quality and a strong community are at the core.",
    "membership.label": "Membership",
    "membership.month": "per month",
    "membership.i1": "Access to the JOH. Boxing programme",
    "membership.i2": "Group classes from the current schedule",
    "membership.i3": "Boxing 101 & technique-conditioning",
    "membership.i4": "Community events",
    "membership.i5": "Path to controlled sparring",
    "membership.info1": "Cancel monthly",
    "membership.info1.tag": "during launch",
    "membership.info2": "€12 one-off",
    "membership.info2.tag": "registration",
    "membership.info3": "Trial available",
    "membership.info3.tag": "free",
    "membership.btn": "Start with JOH. Boxing",

    "about.ch": "— Ch. 07 / The Founder",
    "about.p1": "JOH. was born from the belief that boxing can take people further than just physical fitness.",
    "about.p2": "Founder and head coach Glenn Mulala has more than ten years of experience in boxing. He fought at competition level, won gold at the Northern-Dutch Championships in 2014 and was ranked in the Dutch heavyweight top five in 2015.",
    "about.p3": "With JOH. Boxing he's building a space where quality and accessibility meet — a place where people learn to box, build discipline and become part of a strong community.",
    "about.btn": "Train with JOH.",
    "about.stat1": "Years experience",
    "about.stat2": "Gold NNK '14",
    "about.stat3": "NL '15",

    "vision.ch": "— Ch. 08 / Philosophy",
    "vision.blurb": "At JOH. boxing goes beyond technique and conditioning. It's a way to make body and mind stronger, to build discipline and to develop confidence in yourself. From respect for each other we create a space where everyone is pushed to grow — as a boxer and as a person.",
    "vision.1.t": "Respect",
    "vision.1.b": "Respect for yourself, your coach, your training partner and the sport. Without respect there is no growth.",
    "vision.2.t": "Body & Mind",
    "vision.2.b": "Boxing challenges body and mind at the same time. You become physically stronger, mentally sharper and learn to stay calm under pressure.",
    "vision.3.t": "Discipline",
    "vision.3.b": "Progress comes from showing up, keeping listening and repeating the basics — especially when it gets hard.",
    "vision.4.t": "Confidence",
    "vision.4.b": "Confidence doesn't grow through words but through experience. Every session lets you discover what you're really capable of.",
    "vision.5.t": "Together",
    "vision.5.b": "You develop yourself, but you don't do it alone. We push each other, help each other grow and build a strong community together.",

    "community.ch": "— Ch. 09 / The Group",
    "community.blurb": "At JOH. Boxing it isn't just about individual performance. The group plays a real role in every member's development.",
    "community.invite": "Whether it's your first time in gloves or you've trained for years — you're welcome to become part of JOH.",
    "community.btn": "Join in",

    "pt.ch": "— Ch. 10 / 1:1",
    "pt.blurb": "With personal training you get full attention and a programme built around your level, goals and workload.",
    "pt.g1": "Learn to box", "pt.g2": "Technique", "pt.g3": "Weight loss", "pt.g4": "Conditioning",
    "pt.g5": "Strength & power", "pt.g6": "Confidence", "pt.g7": "Sparring prep", "pt.g8": "Competition",
    "pt.form.title": "— Request / Personal Training",
    "form.name": "Name", "form.email": "Email", "form.phone": "Phone",
    "form.exp": "Experience", "form.goal": "Training goal", "form.day": "Preferred day", "form.msg": "Message",
    "form.name.ph": "First & last name",
    "pt.form.submit": "Request a PT session",

    "trial.ch": "— Ch. 11 / Free trial",
    "trial.blurb": "No experience required. Come meet the class, the coach and the community. Fully free, no commitment.",
    "trial.hint": "Fill in the form — we reply within 24h",
    "trial.form.title": "— Book your free trial",
    "trial.form.submit": "Book your free trial",

    "contact.ch": "— Ch. 12 / Contact",
    "contact.addr": "Rhoneweg 38, 1043 AH",
    "contact.addr.tag": "Amsterdam",
    "contact.form.title": "— Send us a message",
    "contact.subject": "Subject",
    "contact.submit": "Send message",
    "subj.trial": "Trial", "subj.membership": "Membership", "subj.pt": "Personal training",
    "subj.collab": "Collaboration", "subj.youth": "Youth programme", "subj.other": "Other",

    "toast.trial.ok": "Trial booked. Check your email for confirmation.",
    "toast.pt.ok": "Request sent. We'll be in touch shortly.",
    "toast.contact.ok": "Message sent. We'll reply soon.",
    "toast.err": "Something went wrong. Please try again.",
    "loading.send": "Sending…",

    "footer.tag": "Community.",
    "footer.line": "Boxing. Training.",
    "footer.nav": "Navigate",
    "footer.legal": "Legal",
    "footer.terms": "Terms & conditions",
    "footer.privacy": "Privacy policy",
    "footer.follow": "Follow",
    "footer.copy": "© JOH. Boxing 2026. All rights reserved.",
    "footer.made": "Built for the fundamentals. Made in Amsterdam.",

    // Large display headings (styled JSX by default; admin override = plain text)
    "hero.h1.1": "Learn how", "hero.h1.2": "to box.", "hero.h1.3": "Step into", "hero.h1.4": "your potential.",
    "teaser.h1": "The classes.",
    "intro.h1.1": "Boxing is the", "intro.h1.2": "starting", "intro.h1.3": "point.",
    "values.h1.1": "Find your way", "values.h1.2": "into", "values.h1.3": "boxing.",
    "schedule.h1.1": "The week", "schedule.h1.2": "at JOH.",
    "membership.h1.1": "Become", "membership.h1.2": "part", "membership.h1.3": "of JOH.",
    "about.h1.1": "Built from", "about.h1.2": "experience.", "about.h1.3": "Created for", "about.h1.4": "community.",
    "vision.h1.1": "Master the", "vision.h1.2": "fundamentals.",
    "community.h1.1": "We build", "community.h1.2": "each", "community.h1.3": "other.",
    "pt.h1.1": "Your goal.", "pt.h1.2": "Your", "pt.h1.3": "session.",
    "trial.h1.1": "Do you want", "trial.h1.2": "to", "trial.h1.3": "learn", "trial.h1.4": "how to box?",
    "contact.h1.1": "Step", "contact.h1.2": "into", "contact.h1.3": "the", "contact.h1.4": "gym.",

    // Landing page (/welkom + /landingpage)
    "welkom.back": "Full site",
    "welkom.tag": "Welcome / Free trial",
    "welkom.h1.1": "Do you", "welkom.h1.2": "want to learn", "welkom.h1.3": "how to box?",
    "welkom.intro": "No experience needed. Come meet the coach, feel the community and try boxing at your own pace — completely free.",
    "welkom.cta": "Let's get started",
    "welkom.v1.t": "No experience needed", "welkom.v1.b": "Start on day one. The coach guides your first punches, stance and footwork step-by-step.",
    "welkom.v2.t": "Small groups", "welkom.v2.b": "Class caps of 10–16. Personal attention, real feedback, no anonymous crowd.",
    "welkom.v3.t": "Zero commitment", "welkom.v3.b": "One free session. Decide after. No forms, no pressure, no cancellation fees.",
    "welkom.gallery.tag": "This is the gym",
    "welkom.gallery.h1.1": "Real bags.", "welkom.gallery.h1.2": "Real people.",
    "welkom.gallery.p": "Amsterdam-based, community-driven. Documentary shots — no stock, no filters, no clichés.",
    "welkom.steps.tag": "What a trial looks like",
    "welkom.steps.h1.1": "Five steps", "welkom.steps.h1.2": "on the floor.",
    "welkom.s1.t": "Intake & welcome", "welkom.s1.b": "Meet the coach, share your goals, gear check",
    "welkom.s2.t": "Warm-up", "welkom.s2.b": "Rope, footwork, mobility",
    "welkom.s3.t": "Fundamentals", "welkom.s3.b": "Stance, guard, jab, cross",
    "welkom.s4.t": "Bag & pads", "welkom.s4.b": "Combinations, tempo, breathing",
    "welkom.s5.t": "Cool down & next step", "welkom.s5.b": "Stretch, questions, plan your next class",
    "welkom.form.tag": "Book your trial",
    "welkom.form.h1.1": "One tap.", "welkom.form.h1.2": "Zero pressure.",
    "welkom.form.reply": "Reply within 24h",
    "welkom.form.badge": "Free trial · No commitment",
    "welkom.form.submit": "Book my free trial",
  },
};

const mergedDict = {
  nl: { ...dict.nl, ...ptDict.nl },
  en: { ...dict.en, ...ptDict.en },
};

const LangCtx = createContext({ lang: "nl", t: (k) => k, setLang: () => {} });

export const i18nDict = dict;

export function LanguageProvider({ children }) {
  const { content } = useSiteContent();
  const overrides = useMemo(() => content?.text_overrides || {}, [content]);
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "nl";
    const stored = localStorage.getItem("joh_lang");
    if (stored === "nl" || stored === "en") return stored;
    return (navigator.language || "").toLowerCase().startsWith("en") ? "en" : "nl";
  });
  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const setLang = useCallback((l) => {
    if (l !== "nl" && l !== "en") return;
    setLangState(l);
    if (typeof window !== "undefined") localStorage.setItem("joh_lang", l);
  }, []);
  const t = useCallback((k, vars = {}) => {
    const ov = overrides[k];
    let value = ov && typeof ov === "object" && ov[lang] ? ov[lang] : ((mergedDict[lang] && mergedDict[lang][k]) || mergedDict.nl[k] || k);
    return String(value).replace(/\{(\w+)\}/g, (_, name) => vars[name] ?? `{${name}}`);
  }, [lang, overrides]);
  const value = useMemo(() => ({ lang, t, setLang }), [lang, t, setLang]);
  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
}

export function useT() {
  return useContext(LangCtx);
}

// Editable — rendert standaard (gestylde) children, tenzij de admin een
// platte-tekst override heeft opgeslagen voor deze sleutel (text_overrides).
export function Editable({ k, children }) {
  const { lang } = useContext(LangCtx);
  const { content } = useSiteContent();
  const ov = content?.text_overrides?.[k];
  const v = ov && typeof ov === "object" ? ov[lang] : null;
  return v ? <>{v}</> : <>{children}</>;
}
